export const visitors = ({ displayVisitors, editMode }, newUserTimeStorage) => {
  const newTime = new Date();
  let result = true;
  const [savedTimeValue] = newUserTimeStorage || [undefined];
  let savedTime = savedTimeValue;

  if (savedTime) {
    const hasDayPassed =
      new Date(savedTime).getTime() / 1000 + 86400 < newTime.getTime() / 1000;

    if (hasDayPassed) {
      savedTime = null;
    }
  }

  if (displayVisitors === 'newVisitors') {
    result = !savedTime;
  }

  if (displayVisitors === 'returningVisitors') {
    result = !!savedTime;
  }

  window.addEventListener('beforeunload', () => {
    if (!savedTime && newUserTimeStorage) {
      newUserTimeStorage[1].set(newTime);
    }
  });

  if (editMode) {
    return true;
  }

  return result;
};
